var _path, _ellipse, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChurch3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1103 239L1103 267",
    stroke: "#F2DCCE",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1103.5,
    cy: 234.333,
    rx: 16.5,
    ry: 16.3333,
    fill: "#F2DCCE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1098.99 234.19C1098.99 230.283 1102.29 227.117 1106.36 227.117C1106.94 227.117 1107.51 227.184 1108.06 227.308C1106.74 226.48 1105.19 226 1103.52 226C1098.81 226 1095 229.806 1095 234.5C1095 239.194 1098.81 243 1103.52 243C1105.81 243 1107.89 242.093 1109.43 240.62C1108.49 241.032 1107.45 241.263 1106.36 241.263C1102.29 241.263 1098.99 238.096 1098.99 234.19Z",
    fill: "#CC7D61"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1112.4 233.6L1112.37 231.146L1110.54 232.719L1108.3 232.056L1109.11 234.337L1107.77 236.381L1110.1 236.218L1111.5 238.144L1112.13 235.763L1114.34 234.909L1112.4 233.6Z",
    fill: "#CC7D61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChurch3);
export default __webpack_public_path__ + "static/media/church_3.a4ccd0d4a9dfa26ade89df65bb5a8614.svg";
export { ForwardRef as ReactComponent };